import type { TemplateVarsDataItem } from 'types/templates/templates-menu';

type MediaLabels = { image: string; video: string; doc: string };

/** תווית לשדה header מדיה (label מהשרת: image | video | document) — לתצוגה בעברית */
export function getHeaderMediaFieldLabel(
  param: Pick<TemplateVarsDataItem, 'name' | 'label'>,
  media: MediaLabels,
): string {
  if (param.name !== 'data') return '';
  switch (param.label) {
    case 'image':
      return media.image;
    case 'video':
      return media.video;
    case 'document':
      return media.doc;
    default:
      return typeof param.label === 'string' ? param.label : '';
  }
}
